(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fd-aroma-video-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('av-video-slider')) {
  class AromaVideoSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.track = this.querySelector('.av-videos__track');
      this.slides = [...this.querySelectorAll('.av-videos__slide')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.active = this.slides[0];
      this.soundWanted = this.dataset.sound === 'true';
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = false;
      this.playToken = 0;
      if (!this.active) return;
      if (this.slides.length > 2) this.track.prepend(this.slides[this.slides.length - 1]);
      const opts = { signal: this.controller.signal };
      this.querySelector('[data-prev]').addEventListener('click', () => this.step(-1), opts);
      this.querySelector('[data-next]').addEventListener('click', () => this.step(1), opts);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.select(this.slides.find(s => s.dataset.blockId === dot.dataset.dot)), opts));
      this.slides.forEach(slide => {
        const video = slide.querySelector('video');
        video.controls = false;
        video.muted = true;
        slide.querySelector('[data-start]').addEventListener('click', () => {
          this.userPaused = false;
          this.select(slide);
          this.play(slide, true);
        }, opts);
        slide.querySelector('[data-play-toggle]').addEventListener('click', () => {
          if (this.active !== slide) { this.select(slide); this.userPaused = false; this.play(slide, true); return; }
          if (!video.paused) { this.userPaused = true; this.pauseAll(); }
          else { this.userPaused = false; this.play(slide, true); }
        }, opts);
        slide.querySelector('[data-sound-toggle]').addEventListener('click', () => {
          this.soundWanted = !slide.classList.contains('is-audible');
          this.select(slide);
          this.userPaused = false;
          this.play(slide, true);
        }, opts);
        video.addEventListener('play', () => {
          if (slide !== this.active || document.hidden || !this.inView || this.userPaused) { video.pause(); return; }
          this.playerState(slide, true);
        }, opts);
        video.addEventListener('pause', () => this.playerState(slide, false), opts);
        video.addEventListener('volumechange', () => this.soundState(slide, !video.paused && !video.muted && video.volume > 0), opts);
        video.addEventListener('error', () => { video.controls = true; this.playerState(slide, false); }, opts);
        this.playerState(slide, false);
      });
      this.track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.step(event.key === 'ArrowRight' ? 1 : -1); }
      }, opts);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
          const nearest = this.slides.reduce((best, slide) => {
            const rect = slide.getBoundingClientRect();
            const distance = Math.abs(rect.left + rect.width / 2 - center);
            return !best || distance < best.distance ? { slide, distance } : best;
          }, null);
          if (nearest && nearest.slide !== this.active) this.activate(nearest.slide);
        }, 100);
      }, opts);
      document.addEventListener('visibilitychange', () => document.hidden ? this.pauseAll() : this.resume(), opts);
      this.motion.addEventListener('change', () => this.motion.matches ? this.pauseAll() : this.resume(), opts);
      document.addEventListener('shopify:block:select', event => {
        const slide = this.slides.find(s => s.dataset.blockId === event.detail.blockId);
        if (slide) this.select(slide);
      }, opts);
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        if (this.inView) this.resume(); else this.pauseAll();
      }, { threshold: 0.35 });
      this.visibility.observe(this.track);
      this.resize = new ResizeObserver(() => this.center(this.active, false));
      this.resize.observe(this.track);
      this.activate(this.active);
      requestAnimationFrame(() => { if (this.isConnected) this.center(this.active, false); });
    }
    center(slide, smooth = true) {
      const rect = slide.getBoundingClientRect();
      const trackRect = this.track.getBoundingClientRect();
      this.track.scrollTo({ left: this.track.scrollLeft + rect.left + rect.width / 2 - trackRect.left - this.track.clientWidth / 2, behavior: smooth && !this.motion.matches ? 'smooth' : 'instant' });
    }
    step(direction) { this.select(this.slides[(this.slides.indexOf(this.active) + direction + this.slides.length) % this.slides.length]); }
    select(slide) { if (!slide) return; clearTimeout(this.scrollTimer); if (slide !== this.active) this.activate(slide); this.center(slide, false); }
    activate(slide) {
      this.pauseAll(); this.active = slide; this.userPaused = false;
      this.slides.forEach(s => s.classList.toggle('is-active', s === slide));
      this.dots.forEach(dot => { if (dot.dataset.dot === slide.dataset.blockId) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      this.resume();
    }
    resume() { if (this.inView && !document.hidden && !this.userPaused && this.dataset.autoplay === 'true' && !this.motion.matches) this.play(this.active); }
    pauseAll() {
      this.playToken++;
      this.slides.forEach(slide => { const video = slide.querySelector('video'); video.pause(); video.muted = true; this.playerState(slide, false); });
    }
    playerState(slide, playing) {
      slide.classList.toggle('is-playing', playing);
      slide.querySelector('[data-play-toggle]').setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
      const video = slide.querySelector('video');
      this.soundState(slide, playing && !video.muted && video.volume > 0);
    }
    soundState(slide, audible) {
      slide.classList.toggle('is-audible', audible);
      const button = slide.querySelector('[data-sound-toggle]');
      button.setAttribute('aria-pressed', String(audible));
      button.setAttribute('aria-label', audible ? this.dataset.mute : this.dataset.unmute);
      slide.querySelector('[data-sound-label]').textContent = audible ? this.dataset.mute : this.dataset.unmute;
    }
    async play(slide, manual = false) {
      if (!slide || document.hidden || slide !== this.active) return;
      if (!manual && (this.motion.matches || this.userPaused || this.dataset.autoplay !== 'true' || !this.inView)) return;
      const video = slide.querySelector('video');
      const token = ++this.playToken;
      video.muted = !this.soundWanted;
      try { await video.play(); }
      catch (error) {
        if (token !== this.playToken || slide !== this.active || document.hidden || !this.inView || this.userPaused) return;
        if (error.name === 'NotAllowedError' && !video.muted) {
          video.muted = true;
          try { await video.play(); } catch (retryError) { this.playerState(slide, false); }
        } else { this.playerState(slide, false); }
      }
      if (token !== this.playToken) return;
      if (!this.isConnected || slide !== this.active || document.hidden || !this.inView || this.userPaused) { video.pause(); video.muted = true; return; }
      this.playerState(slide, !video.paused);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.visibility?.disconnect(); this.resize?.disconnect(); clearTimeout(this.scrollTimer);
      if (this.slides) this.pauseAll();
      this.initialized = false;
    }
  }
  customElements.define('av-video-slider', AromaVideoSlider);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-brand-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fd-brand-carousel')) {
  customElements.define('fd-brand-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewport = this.querySelector('[data-brand-viewport]');
      this.track = this.querySelector('[data-brand-track]');
      this.group = this.querySelector('[data-brand-group]');
      this.button = this.querySelector('[data-brand-toggle]');
      if (!this.group?.children.length) return;
      this.querySelector('[data-brand-copy]')?.remove();
      this.copy = this.group.cloneNode(true);
      this.copy.removeAttribute('data-brand-group');
      this.copy.setAttribute('data-brand-copy', '');
      this.copy.setAttribute('aria-hidden', 'true');
      this.copy.querySelectorAll('a').forEach(link => link.setAttribute('tabindex', '-1'));
      this.track.append(this.copy);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.visible = true;
      this.hovered = false;
      this.focused = false;
      this.reducedMotion.addEventListener('change', () => this.measure(), options);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-fd-brand-link]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const filters = document.getElementById('collection-filters');
        if (typeof filters?.renderSectionFromFetch !== 'function') return;
        event.preventDefault();
        filters.renderSectionFromFetch(link.href, true);
      }, options);
      this.button.addEventListener('click', () => { this.paused = !this.paused; this.updateButton(); this.schedule(); }, options);
      this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
      this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.viewport.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') { this.paused = true; this.updateButton(); this.schedule(); } }, options);
      this.viewport.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.viewport.addEventListener('focusout', event => { if (!this.viewport.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.resizeObserver?.disconnect();
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.visibilityObserver.observe(this);
      this.measure();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.frame);
    }
    measure() {
      this.distance = this.group.getBoundingClientRect().width;
      this.canMove = this.group.children.length > 1 && this.distance > this.viewport.clientWidth + 2;
      this.copy.hidden = !this.canMove || this.reducedMotion.matches;
      this.toggleAttribute('data-static', !this.canMove);
      this.button.hidden = !this.canMove || this.reducedMotion.matches;
      if (!this.canMove) this.viewport.scrollLeft = 0;
      this.updateButton();
      this.schedule();
    }
    restorePosition(position, focusedBrand) {
      if (position != null) this.viewport.scrollLeft = position;
      if (focusedBrand !== undefined) {
        const target = Array.from(this.group.querySelectorAll('[data-fd-brand-link]')).find(link => link.dataset.fdBrandLink === focusedBrand);
        target?.focus({ preventScroll: true });
      }
      this.schedule();
    }
    updateButton() {
      this.button.setAttribute('aria-pressed', String(this.paused));
      this.button.setAttribute('aria-label', this.paused ? this.button.dataset.playLabel : this.button.dataset.pauseLabel);
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.lastTime = 0;
      if (!this.canMove || this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.reducedMotion.matches) return;
      this.position = this.viewport.scrollLeft;
      const tick = time => {
        if (!this.isConnected) return;
        if (this.lastTime) {
          this.position += Math.min(time - this.lastTime, 64) * (Number(this.dataset.speed) || 24) / 1000;
          if (this.position >= this.distance) this.position %= this.distance;
          this.viewport.scrollLeft = this.position;
        }
        this.lastTime = time;
        this.frame = requestAnimationFrame(tick);
      };
      this.frame = requestAnimationFrame(tick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fd-delivery-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-fd-delivery-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const filters = document.getElementById('collection-filters');
    if (typeof filters?.renderSectionFromFetch !== 'function') return;
    event.preventDefault();
    filters.renderSectionFromFetch(link.href, true);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fod-viber-order"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.fodViberOrderReady) return;
    window.fodViberOrderReady = true;
    const updateLink = (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('[data-fod-viber-order]');
      if (!link) return;
      const form = document.getElementById(link.dataset.formId);
      const variant = form?.elements.namedItem('id')?.value;
      const quantityValue = Number(form?.elements.namedItem('quantity')?.value || link.dataset.minQuantity || 1);
      const quantity = Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1;
      const productUrl = new URL(link.dataset.productUrl);
      if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
      const chatUrl = new URL(link.dataset.chatUrl);
      if (chatUrl.protocol !== 'https:' || chatUrl.hostname !== 'viber.me') return;
      const draft = `${link.dataset.intro}\n${link.dataset.quantityLabel} ${quantity}\n${productUrl.href}`;
      link.href = `${chatUrl.href.split('?')[0]}?draft=${encodeURIComponent(draft)}`;
    };
    document.addEventListener('pointerdown', updateLink, true);
    document.addEventListener('focusin', updateLink, true);
    document.addEventListener('click', updateLink, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
